import { Skeleton } from '@medifind/shared-basic-components';
import { numberWithCommas } from '@medifind/utils';

export const TotalResults = ({ totalResults, foundText }) => {
  return <>{totalResults != null ? `${numberWithCommas(totalResults)} ${foundText}` : <Skeleton style={{ maxWidth: 200 }} />}</>;
};
